import React from 'react'

const PageNotFound = () => {
  return (
    <div className="page-not-found">
      <h1>PageNotFound 404</h1>
    </div>
  )
}

export default PageNotFound
